/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getExamSubjectsListPagination, manageExamSubjectData, resetExamSubject, resetExamSubjectsList } from '../actions/masterManagementAction';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json';
import TablePagination from '../../../common/components/TablePagination';
import ConfirmationDialog from '../../../common/components/ConfirmationDialog';
import ExamSubjectForm from './ExamSubjectForm';

const ExamSubjectList = () => {
  let rowPerPage = 10;
  const dispatch = useDispatch();
  let [addExamSubject, setAddExamSubject] = useState({ "Mode": false, "id": '', "name": '', "name_dvng": "", "code": '', "parent_exam_subject_id": '' });
  let [searchMode, setSearchMode] = useState(false);
  let [examSubjectName, setExamSubjectName] = useState('');
  let [examSubjectParentId, setExamSubjectParentId] = useState('');
  let [examSubjectCode, setExamSubjectCode] = useState('');
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [showModal, setShowModal] = useState(false);
  let [deleteExamSubject, setDeleteExamSubject] = useState(0);

  useEffect(() => {
    dispatch(resetExamSubject());
    dispatch(resetExamSubjectsList());
    dispatch(getExamSubjectsListPagination(0, rowPerPage, examSubjectName));
    // eslint-disable-next-line
  }, [])

  const searchData = (textToSearch) => {
    setSearchMode(Number(new Date()));
    dispatch(getExamSubjectsListPagination(0, rowPerPage, textToSearch));
  }

  const { examSubjectsListData, examSubjectPageNoCounter } = useSelector((state) => state.masterManagementReducer, shallowEqual);
  let tableCounter = examSubjectPageNoCounter + 1;

  const manageExamSubject = (id) => {
    setShowModal(true);
    setDeleteExamSubject(id);
  }

  const deleteExamSubjectData = (id) => {
    setShowModal(false);
    let requestBody = {
      "examSubject":
      {
        "id": id,
        "isDeleted": true
      }
    };
    let totalRecords = examSubjectsListData.totalNumberOfRecords;
    let remainder = totalRecords % rowPerPage;

    if (remainder == 1) {
      listCurrentPage = listCurrentPage - 1;
    }
    setListCurrentPage(listCurrentPage);
    dispatch(manageExamSubjectData(requestBody, rowPerPage, listCurrentPage));
  }

  const activeExamSubject = (id, isActive) => {
    let requestBody = { "examSubject": { "id": id, "isActive": !isActive } };
    dispatch(manageExamSubjectData(requestBody, rowPerPage, listCurrentPage));
  }

  return addExamSubject.Mode != false ? (
    <div>
      <ExamSubjectForm
        addExamSubject={addExamSubject}
        setAddExamSubject={setAddExamSubject}
        examSubjectName={examSubjectName}
        examSubjectCode={examSubjectCode}
        setExamSubjectName={setExamSubjectName}
        examSubjectParentId={examSubjectParentId}
        setExamSubjectParentId={setExamSubjectParentId}
        setExamSubjectCode={setExamSubjectCode}
      />
    </div>
  ) : (
    <div className="border border-light w-100 p-4">
      <div className='form-group'>
        <div className='d-flex align-items-center gap-4'>
          <label className='font-weight-bold float-left text-nowrap' >{masterLabels.examSubjectList.Name}<span className="redColor">*</span></label>
          <input
            type="text"
            className="form-control"
            name="examSubjectName"
            value={examSubjectName}
            placeholder={masterLabels.examSubjectList.Search_Label}
            onChange={event => (setExamSubjectName(event.target.value), setSearchMode(false))}
            maxLength="50"
          />
          <div className='col-md-1'>
            <button className='form-control  btn btn-primary custom_button  button_search  ' onClick={() => { searchData(examSubjectName); }}><i className="fa fa-search" type="button" ></i></button>
          </div>
          <div className='col-md-2 text-right'>
            <button className='form-control  btn btn-primary custom_button   ' onClick={() => { setExamSubjectName(''); setAddExamSubject({ "Mode": "Add" }) }}>
              {masterLabels.examSubjectList.Add_ExamSubject}
            </button>
          </div>
        </div>
      </div>
      <br />
      <div className='form-group'>
        {examSubjectsListData && examSubjectsListData.totalNumberOfRecords > 0 ? <div className='row'>
          <div className='col-md-12'>
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  {/* <th scope="col" className='w-10 text-center'>{masterLabels.examSubjectList.No}</th> */}
                  <th scope="col" className='w-10 text-center'>{masterLabels.examSubjectList.Id}</th>
                  <th scope="col" className='w-10 text-center'>{masterLabels.examSubjectList.Code}</th>
                  <th scope="col" className='w-40 text-left'>{masterLabels.examSubjectList.Name}</th>
                  <th scope="col" className='w-40 text-left'>{masterLabels.examSubjectList.Name_dvng}</th>
                  <th scope="col" className='w-10 text-center'>{masterLabels.examSubjectList.Action}</th>
                </tr>
              </thead>
              <tbody className='small'>
                {examSubjectsListData && examSubjectsListData.examSubjectList && examSubjectsListData.examSubjectList.map((element, index) => {
                  if (element) {
                    return (
                      <tr key={index}>
                        {/* <td className="text-center">{tableCounter++}</td> */}
                        <td className="text-center">{element.id}</td>
                        <td className="text-center">{element.code}</td>
                        <td className="text-left">{element.name}</td>
                        <td className="text-left">{element.nameDvng}</td>
                        <td className="w-10 text-center d-flex">
                          <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_EDIT} className='text-primary fa fa-edit' onClick={() => { setAddExamSubject({ "Mode": "Edit", "id": element.id, "name": element.name, "code": element.code, "name_dvng": element.nameDvng, "parentId": element.parentExamSubjectId }); }}></i>
                          &nbsp;&nbsp;
                          <i role="button" data-toggle="tooltip" title={element.isActive ? commonLabels.BUTTON_INACTIVE : commonLabels.BUTTON_ACTIVE}
                            className={element.isActive === true ? "text-success fa fa-toggle-on" : "text-danger fa fa-toggle-off"} onClick={(e) => { activeExamSubject(element.id, element.isActive); }}></i>
                          &nbsp;&nbsp;
                          <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_DELETE} className='text-danger fa fa-trash' onClick={(e) => { manageExamSubject(element.id); }}></i>
                        </td>
                      </tr>
                    )
                  }
                })
                }
              </tbody>
            </table>
            {examSubjectsListData &&
              <TablePagination
                paginationFor="exam_subject_list"
                rowPerPage={rowPerPage}
                setListCurrentPage={setListCurrentPage}
                textToSearch={examSubjectName}
                searchMode={searchMode}
                totalCount={examSubjectsListData.totalNumberOfRecords}
              />
            }
          </div></div>
          :
          <div className='text-center'>
            <font className="text-danger">{commonLabels.NO_DATA_FOUND}
            </font>
          </div>}
      </div>

      {
        <ConfirmationDialog
          showModal={showModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_MESSAGE}
          setShowModal={setShowModal}
          deleteRecord={deleteExamSubjectData}
          deletedId={deleteExamSubject}
          IsConfirmation={"true"}
        />
      }
    </div>
  );
}

export default ExamSubjectList;